// Lib
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { Form, useFormikContext } from 'formik'
import _ from 'lodash'

// Images
import deleteSVG from 'images/commons/delete.svg'
import closeSVG from 'images/commons/close.svg'

// Include in project
import styles from './index.module.scss'
import { Button, SelectSingle, TextField } from 'component'
import type { RootState } from 'states/store'
import { setOpenDialog } from 'states/slice/modalDialog'
import { ETransformationDataToServer } from 'utils/tranformData'
import { useHandleActionMasterData } from 'hooks'

interface Props {
  openModal: boolean
  closeModal: () => void
  refetchDistrictList: any
  refetchDistrictTrashList: any
  createDistrict: any
  updateDistrict: any
  deleteDistrict: any
}

const ModalOfDistrict: React.FC<Props> = (props: Props): JSX.Element => {
  const { values, errors, handleSubmit } = useFormikContext<any>()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const getProvinceListReducer = useSelector((state: RootState) => state.province)

  const { handleUpdate, handleDelete } = useHandleActionMasterData({
    errors,
    values,
    createMasterData: props.createDistrict,
    updateMasterData: props.updateDistrict,
    typeUpdateMasterData: ETransformationDataToServer.UpdateDistrict,
    deleteMasterData: props.deleteDistrict,
    refetchMasterData: props.refetchDistrictList,
    refetchMasterDataTrashList: props.refetchDistrictTrashList,
    closeModal: props.closeModal,
    key: 'districtID',
  })

  return (
    <Modal open={props.openModal} onClose={props.closeModal}>
      <Form className={styles.containerModal}>
        <div className={styles.section}>
          {values.formInput.districtID ? (
            <h3>{t('districtManagement.haveDataTitle')}</h3>
          ) : (
            <h3>{t('districtManagement.newTitle')}</h3>
          )}
          <img className={styles.closeIcon} src={closeSVG} alt="closeSVG" onClick={props.closeModal} />
        </div>
        <TextField name={`formInput.districtName`} type="text" label="District Name" require />
        <SelectSingle
          name="formInput.provinceID"
          option={getProvinceListReducer.provinceListOption}
          disabled={false}
          label="Province"
          require
        />

        <div className={styles.rowButton}>
          {values.formInput.districtID && (
            <div className={styles.button}>
              <Button
                typeButton="button"
                type={'outline'}
                disabled={false}
                name={t<string>('common.delete')}
                icon={deleteSVG}
                fullWidth
                functionOnClick={() =>
                  dispatch(
                    setOpenDialog({
                      title: t<string>('districtManagement.deleteTitle'),
                      description: t<string>('districtManagement.deleteDescription'),
                      status: 'danger',
                      functionOnSubmit: handleDelete,
                    }),
                  )
                }
              />
            </div>
          )}
          <div className={styles.button}>
            <Button
              typeButton="submit"
              type={'primary'}
              disabled={false}
              name={t<string>('common.save')}
              fullWidth
              functionOnClick={() => {
                handleSubmit()
                handleUpdate()
              }}
            />
          </div>
        </div>
      </Form>
    </Modal>
  )
}

export default ModalOfDistrict
